import { PermissionActions } from '@/features/permissions/permissionActions.js'
import SuperAdminDummyRouter from '@/features/superAdmin/SuperAdminDummyRouter.vue'

export const registrationManagementRoutes = [
  {
    path: 'registration-management',
    component: SuperAdminDummyRouter,
    meta: { permissionAction: PermissionActions.RegistrationFormsView },
    children: [
      {
        path: '',
        component: () =>
          import('@/features/settingsManagement/registrationManagement/list/RegFormInitialScreen.vue'),
        meta: { permissionAction: PermissionActions.RegistrationFormsView },
      },
      {
        path: ':templateId',
        component: () =>
          import('@/features/settingsManagement/registrationManagement/edit/RegFormEditView.vue'),
        meta: {
          showSidebar: false,
          layoutPadding: false,
          permissionAction: PermissionActions.RegistrationFormsView,
        },
      },
    ],
  },
]
